import { BaseService } from '@common/http-layer/service/base.service'
import { useLocation } from '@common/location-layer/composables/useLocation'

import type { IProductDetail } from '@courses/types-layer/types/product'

export class ProductService extends BaseService {
  constructor() {
    super({
      baseURL: 'MEMBERSHIPS_SERVER_URL',
      basePath: '',
    })
  }

  private endpoint(path: string = '', locationId?: string): string {
    const { store: state } = useLocation()
    if (!state.locationId) throw new Error('Location ID is required')
    return `/locations/${locationId ? locationId : state.locationId}/products${path}`
  }

  async pinProduct(productId: string) {
    const { data } = await this.post(this.endpoint(`/${productId}/pin`))
    return data
  }

  async unpinProduct(productId: string) {
    const { data } = await this.post(this.endpoint(`/${productId}/unpin`))
    return data
  }

  async pinnedProducts() {
    const { data } = await this.get<IProductDetail[]>(this.endpoint(`/pinned`))
    return data
  }

  async findById(id: string): Promise<IProductDetail> {
    const { data } = await this.get<IProductDetail>(this.endpoint(`/${id}`))
    return data
  }

  async getCustomizationSettings(productId: string, locationId: string, params?: Record<string, unknown>) {
    const { data } = await this.get(this.endpoint(`/product-themes/${productId}`), {
      params,
      locationId,
      productId,
    })
    return data
  }

  async getProductTemplateByProductId(productId: string, locationId: string) {
    const { data } = await this.get(this.endpoint(`/themes-v2/${productId}`, locationId), {
      locationId,
      productId,
    })
    return data
  }

  async checkIfProductThemeExists(productId: string, locationId: string) {
    const { data } = await this.get(this.endpoint(`/themes-v2/${productId}/check-exists`, locationId), {
      locationId,
      productId,
    })
    return data
  }

  async getProductTemplateById(id: string, productId: string, locationId: string) {
    const { data } = await this.get(this.endpoint(`/themes-v2/${productId}/theme/${id}`, locationId), {
      locationId,
      productId,
    })
    return data
  }

  async getTemplateById(id: string, productId: string, locationId: string) {
    const { data } = await this.get(this.endpoint(`/themes-v2/templates/${id}`, locationId), {
      locationId,
      productId,
    })
    return data
  }
}
